var map = {
	"./bash": 1817,
	"./java": 1818,
	"./json": 1819,
	"./julia": 1820,
	"./python": 1821,
	"./r": 1822,
	"./rust": 1823,
	"./scala": 1824,
	"./shell": 1825,
	"./sql": 1826,
	"./xml": 1827,
	"./yaml": 1828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1816;